import { downloadStringAsFile } from '../../../Utils/Misc'

export const validateCsvFlyerCodesData = (csvData, campaignData) =>
  csvData.forEach(code => {
    const campaignName = code.CAMPAIGN_NAME.trim()
    const cityName = code.CITY_NAME.trim()
    const campaign = campaignData[campaignName]

    if (!Object.keys(campaignData).includes(campaignName)) {
      throw new Error(
        `Code: ${
          code.FLYER_CODE
        } has an incorrect reference to the campaign, received: "${campaignName}"`,
      )
    }
    if (!Object.keys(campaign.cityPlans).includes(cityName)) {
      throw new Error(
        `Campaign: ${campaignName} has no city plans in "${cityName}"`,
      )
    }
  })
/**
 * prepare data to request
 * @param {object} data - data from uploadede file campaignData
 * @param {object} campaignData - needeed for calculation  campaignId , clientId and cityId
 * @return {object}
 */
export const formatFlyerCodesData = (data, campaignData) => {
  return data.map(code => {
    const campaign = code.CAMPAIGN_NAME.trim()
    return {
      flyerCode: code.FLYER_CODE,
      campaignId: campaignData[campaign].value,
      cityId: campaignData[campaign].cityPlans[code.CITY_NAME.trim()].id,
      clientId: campaignData[campaign].clientId,
      quantity: Number(code.QUANTITY),
      tag: code.TAG,
    }
  })
}

/**
 * parse data from request
 * @param {object} data - campaign data
 *
 * @return {object}
 */
export const formatFlyerCodesGQLData = data =>
  data.campaigns.edges.reduce((acc, { node }) => {
    acc[node.name] = {
      cityPlans: node.cityPlans.nodes.reduce((acc, node) => {
        acc[node.city.name] = {
          id: node.city.id,
          name: node.city.name,
          status: node.city.statusV2,
        }
        return acc
      }, {}),
      clientId: node.client.id,
      label: node.name,
      value: node.id,
    }
    return acc
  }, {})

/**
 * download flyer codes  template
 */
export const downloadFlyerCodesTemplate = () => {
  var sampleData = {
    'CAMPAIGN_NAME': '',
    'CITY_NAME': '',
    'FLYER_CODE': '',
    'QUANTITY': '',
    'TAG': '',
  }

  downloadStringAsFile(
    Object.keys(sampleData).join(',') +
      '\n' +
      Object.values(sampleData).join(','),
    `flyer-codes-data-example.csv`,
  )
}



// WEBPACK FOOTER //
// ./src/Containers/Header/Modals/util.js